import { Observable } from 'rxjs';

import { MatrixProcessMessage } from '@/models/matrix-error-response';
import HttpClient from '@/resources/http/client';

function uploadMatrix<T>(matrix: File, url: string): Observable<T> {
  const body = new FormData();
  body.append('matrix', matrix, matrix.name);
  const headers = { Accept: 'application/x-ndjson' };
  return HttpClient.post<T>(url, { body, headers });
}

export function insertMatrix(matrix: File): Observable<MatrixProcessMessage> {
  return uploadMatrix(matrix, '/api/recap/matrix/upload');
}

export function controlMatrix(matrix: File): Observable<MatrixProcessMessage> {
  return uploadMatrix(matrix, '/api/recap/matrix/control');
}
